import { bopApi } from '@/lib/api/client';

const ACCOUNTS_PATH = 'v1/funds/kinexys/accounts';

/** Wire shape from GET v1/funds/kinexys/accounts */
export interface KinexysAccount {
  id: string;
  bic: string;
  name: string;
  currency: string;
  dda_id: string;
  dda_bic: string;
  account_type: string;
  balance_available: number | null;
  balance_updated_at: string | number | null;
  auto_update_balance_enabled: boolean;
  auto_rebalance_enabled: boolean;
  min_balance: number | null;
  max_balance: number | null;
}

export interface KinexysAccountsResponse {
  accounts: KinexysAccount[];
}

/** PATCH body — the account id travels in the path, never in the body. */
export type KinexysAccountUpdate = { auto_update_balance_enabled: boolean } | { auto_rebalance_enabled: boolean; min_balance?: number | null; max_balance?: number | null };

export const getKinexysAccounts = () => bopApi.get(ACCOUNTS_PATH).json<KinexysAccountsResponse>();

// .text() defensively — the response shape is unused (callers invalidate + refetch),
// and an empty success body must not blow up a JSON parse.
export const updateKinexysAccount = (accountId: string, update: KinexysAccountUpdate) => bopApi.patch(`${ACCOUNTS_PATH}/${accountId}`, { json: update }).text();

// Currency ascending, then account_type DESCENDING; both fields guarded against
// missing values so a partial record cannot crash the sort.
export const sortKinexysAccounts = (accounts: KinexysAccount[]): KinexysAccount[] =>
  [...accounts].sort((a, b) => (a.currency ?? '').localeCompare(b.currency ?? '') || (b.account_type ?? '').localeCompare(a.account_type ?? ''));
